"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Feature = void 0;
/**
 * Laravel Pennant feature flags, keyed by their fully-qualified backend class
 * name (the same string used as keys in `Organization.features`).
 *
 * Mirrors the platform web enum at `resources/ts/Types/Features.ts`. Keep the
 * two in sync when flags are added or removed.
 */
var Feature;
(function (Feature) {
    Feature["EVENTS"] = "App\\Features\\Events";
    Feature["DUES"] = "App\\Features\\Dues";
    Feature["POS"] = "App\\Features\\PointOfSale";
    Feature["APP_STATS_GLOBAL_ADMIN"] = "App\\Features\\AppStatsGlobalAdmin";
    Feature["APP_STATS"] = "App\\Features\\AppStats";
    Feature["APP_COACH_PASSES"] = "App\\Features\\AppCoachPasses";
    Feature["APP_AI"] = "App\\Features\\AppAi";
    Feature["APP_CHAT"] = "App\\Features\\AppChat";
    Feature["PAY_IN_PERSON"] = "registration.payInPerson";
})(Feature || (exports.Feature = Feature = {}));
